<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editFormcaigoufukuan" ref="editFormcaigoufukuanRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">采购订单号(必填)</span>
          </label>
          <el-input v-model="editFormcaigoufukuan.orderidcaigou" disabled></el-input>
          <el-button type="success" plain @click="apiCheckCaiGouOrderid">校验</el-button>
          <li>订单总金额：{{editFormcaigoufukuan.totalMoney}}</li>
          <li>已付款/付款中金额：{{editFormcaigoufukuan.havePayMoney}}</li>
          <li>剩余可付款金额：{{editFormcaigoufukuan.allowMoney}}</li>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">收款单位(必填)</span>
          </label>
          <el-input v-model="editFormcaigoufukuan.shoukuandanwei"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">银行账号(必填)</span>
          </label>
          <el-input v-model="editFormcaigoufukuan.yinhangzhanghao"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">开户行(必填)</span>
          </label>
          <el-input v-model="editFormcaigoufukuan.kaihuhang"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">付款原因(必填)</span>
          </label>
          <el-input v-model="editFormcaigoufukuan.reason"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">金额(必填)</span>
          </label>
          <el-input v-model="editFormcaigoufukuan.money"></el-input>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="editFormcaigoufukuan.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          默认采用上次的附件，如果附件有改动，请把所有附件都重新上传。
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      editFormcaigoufukuan: {
        id: 0,
        orderidcaigou: '',
        shoukuandanwei: '',
        yinhangzhanghao: '',
        kaihuhang: '',
        reason: '',
        money: '',
        beizhu: '',
        attachment: '',
        totalMoney: '',
        havePayMoney: '',
        allowMoney: ''
      }
    }
  },
  mounted () {

  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.editFormcaigoufukuan.id = row.Id
      this.editFormcaigoufukuan.orderidcaigou = row.Orderidcaigou
      this.editFormcaigoufukuan.shoukuandanwei = row.Shoukuandanwei
      this.editFormcaigoufukuan.yinhangzhanghao = row.Yinhangzhanghao
      this.editFormcaigoufukuan.kaihuhang = row.Kaihuhang
      this.editFormcaigoufukuan.reason = row.Reason
      this.editFormcaigoufukuan.money = row.Money
      this.editFormcaigoufukuan.beizhu = row.Beizhu
      this.editFormcaigoufukuan.attachment = row.Attachment
      this.apiCheckCaiGouOrderid()

      this.$refs.MultiImgOrPdf.cleardata()
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditShenPiNewFyBxChaiLv3()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.editFormcaigoufukuan.attachment = url
    },
    apiCheckCaiGouOrderid: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderidcaigou: that.editFormcaigoufukuan.orderidcaigou
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckCaiGouOrderid, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.editFormcaigoufukuan.orderidcaigou = response.data.Orderidcaigou
            that.editFormcaigoufukuan.totalMoney = response.data.TotalMoney
            that.editFormcaigoufukuan.havePayMoney = response.data.HavePayMoney
            that.editFormcaigoufukuan.allowMoney = response.data.AllowMoneys
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditShenPiNewFyBxChaiLv3: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editFormcaigoufukuan.id,
        orderidcaigou: that.editFormcaigoufukuan.orderidcaigou,
        shoukuandanwei: that.editFormcaigoufukuan.shoukuandanwei,
        yinhangzhanghao: that.editFormcaigoufukuan.yinhangzhanghao,
        kaihuhang: that.editFormcaigoufukuan.kaihuhang,
        reason: that.editFormcaigoufukuan.reason,
        money: that.editFormcaigoufukuan.money,
        beizhu: that.editFormcaigoufukuan.beizhu,
        attachment: that.editFormcaigoufukuan.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditShenPiNewFyBxChaiLv3, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
